export default __webpack_public_path__ + "static/media/copper_promise.5b702f47.svg";